import { Box, Flex, Text } from '@everlywell/ui-kit';
import React from 'react';

import DynamicIcon from '../../../DynamicIcon/DynamicIcon';

export type BenefitCardDescriptionBulletProps = {
  iconName?: string | null;
  iconColor?: string | null;
  title?: string | null;
  description?: string | null;
  textColor?: string | null;
  primaryColor?: string | null;
};

/**
 * BenefitCardDescriptionBullet component
 * A component that renders a bullet point with an icon, title, and description.
 * Used in the BenefitCardDescription component to display feature benefits.
 * @param {string | null} [props.iconName] Name of the icon to display
 * @param {string | null} [props.iconColor] Color of the icon
 * @param {string | null} [props.title] Title text for the bullet point
 * @param {string | null} [props.description] Description text for the bullet point
 * @returns {JSX.Element} BenefitCardDescriptionBullet component
 */
const BenefitCardDescriptionBullet = ({
  iconName,
  iconColor,
  title,
  description,
  textColor,
  primaryColor,
}: BenefitCardDescriptionBulletProps) => (
  <Flex alignItems="flex-start" gap="2">
    {iconName && (
      <Box>
        <DynamicIcon icon={iconName as any} color={iconColor} size="md" />
      </Box>
    )}
    <Flex flexDirection="column" gap="0">
      {title ? (
        <Text
          color={primaryColor || 'tints.white'}
          fontSize={['md', null, 'xl']}
          fontWeight="medium"
        >
          {title}
        </Text>
      ) : null}
      {description ? (
        <Text color={textColor || 'tints.white'} fontSize={['md', null, 'xl']} opacity="0.8">
          {description}
        </Text>
      ) : null}
    </Flex>
  </Flex>
);

export default BenefitCardDescriptionBullet;
